export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH: 'refresh',
  TENANT: 'tenant',
  USER_ID: 'user_id',
  BILL_MISMATCH_ALERT: 'billMismatchAlertIgnored',
  PER_PAGE: 'per_page',
  PAGE_NUMBER: 'pageNumber',
  DCT_FILTERS: 'dctFilters',
  SCHEDULAR_MODE: 'schedularMode',
};
